import { MarketType } from 'constants/markets';
import { GetServerSidePropsContext } from 'next';
import {
    GetCategoriesDocument,
    GetCategoriesQuery,
    GetCategoryDocument,
    GetCategoryQuery, GetCategorySlugsDocument, GetCategorySlugsQuery,
    GetProductDocument,
    GetProductQuery,
    GetProductsDocument,
    GetProductsQuery, GetPublicProductsDocument, GetPublicProductsQuery,
    GetRecommendedProductsDocument,
    GetRecommendedProductsQuery,
    GetRecommendedRelatedProductsDocument,
    GetRecommendedRelatedProductsQuery,
} from '../generated/graphql';
import { authorizedQuery } from './authorizedClient';
import { query } from './client';

export const getProductBySlug = (
    context: GetServerSidePropsContext,
    market: string,
    slug: string,
    organisationPersonalWebshopSlug?: string,
) => authorizedQuery<GetProductQuery>(context, {
    query: GetProductDocument,
    variables: { market, slug, organisationPersonalWebshopSlug },
});

export const getProductBySku = (
    context: GetServerSidePropsContext,
    market: string,
    sku: string,
    organisationPersonalWebshopSlug?: string,
) => authorizedQuery<GetProductQuery>(context, {
    query: GetProductDocument,
    variables: { market, sku, organisationPersonalWebshopSlug },
});

export const getProductsBySku = (
    market: MarketType,
    sku: string[],
) => query<GetPublicProductsQuery>(market, {
    query: GetPublicProductsDocument,
    variables: { market, sku },
});

export function getProductsByMarket(
    market: MarketType,
    from: number,
    size = 12,
    slug?: string | null,
) {
    return query<GetProductsQuery>(market, {
        query: GetProductsDocument,
        variables: {
            market,
            from,
            size,
            category_slug_path: slug,
        },
    });
}

export function getRecommendedProducts(
    market: MarketType,
    organisationPersonalWebshopSlug?: string,
) {
    return query<GetRecommendedProductsQuery>(market, {
        query: GetRecommendedProductsDocument,
        variables: { market, organisationPersonalWebshopSlug },
    });
}

export function getRecommendedRelatedProducts(
    market: MarketType,
    slug: string,
    organisationPersonalWebshopSlug?: string,
) {
    return query<GetRecommendedRelatedProductsQuery>(market, {
        query: GetRecommendedRelatedProductsDocument,
        variables: { market, slug, organisationPersonalWebshopSlug },
    });
}

export function getProductsBySearch(market: MarketType, from: number, size = 12) {
    return query<GetProductsQuery>(market, {
        query: GetProductsDocument,
        variables: {
            market,
            from,
            size,
        },
    });
}

export function getCategoriesByMarket(market: MarketType) {
    return query<GetCategoriesQuery>(market, {
        query: GetCategoriesDocument,
        variables: { market },
    });
}

export function getCategorySlugsByMarket(market: MarketType) {
    return query<GetCategorySlugsQuery>(market, {
        query: GetCategorySlugsDocument,
        variables: { market },
    });
}

export function getCategoryBySlug(market: MarketType, slug: string, showAllProducts: boolean = false) {
    return query<GetCategoryQuery>(market, {
        query: GetCategoryDocument,
        variables: {
            market,
            slug,
            showAllProducts,
        },
    });
}
